import React from "react";
import { Button } from "antd";
import SVGIcon from "../../../utils/SVGIcon";
import { ButtonProps } from "../../Buttons/interface/ButtonInterface";
import { useAppSelector } from "../../../utils/hooks/hooks";

const ResultButton: React.FC<Partial<ButtonProps>> = ({
  action,
  data,
  title,
  permission = true,
  iconProps,
  ...rest
}) => {
  const [loading,id,resultName] =useAppSelector((state)=>state.common.assessmentResultLoading)

  if (!permission) {
    return null;
  }

  delete rest?.permissionKey;

  return (
    <Button
      type="text"
      title={title}
      loading={loading&&(data.id===id)&&(title===resultName)&&loading}
      className=""
      onClick={() => action && action(data)}
      {...rest}
    >
      {loading&&(data.id===id)&&(title===resultName)?'':<SVGIcon icon="view" width={16} {...iconProps} />}
    </Button>
  );
};

export default ResultButton;
